import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { NavBar } from "./components/NavBar";
import { About } from "./components/About";
import { PostList } from "./components/PostList";
import { PostDetail } from "./components/PostDetail";
import { Footer } from "./components/Footer";

export default function App() {
  return (
    <Router>
      <div className="site-shell">
        <header className="site-header">
          <NavBar />
        </header>
        <main className="site-main">
          <Routes>
            <Route path="/blog" element={<PostList />} />
            <Route path="/blog/:id" element={<PostDetail />} />
            <Route path="/" element={<About />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}
